import { Link } from "react-router-dom";

import { useSiteSettings } from "@/hooks/use-site-settings";

const COLUMNS = [
  { title: "Browse", links: [
    { label: "All Questions", to: "/explore" },
    { label: "By Book", to: "/explore/books" },
    { label: "By Person", to: "/explore/people" },
    { label: "By Type of Question", to: "/explore/types" },
    { label: "By Theme", to: "/explore/themes" },
  ] },
  { title: "Study", links: [
    { label: "Bible Reader", to: "/read", testId: "footer-reader-link" },
    { label: "Commentaries", to: "/commentary" },
    { label: "Daily Spark", to: "/daily" },
    { label: "Blog", to: "/blog", testId: "footer-blog-link" },
    { label: "Dashboard", to: "/dashboard" },
  ] },
  { title: "About", links: [
    { label: "Why We Ask", to: "/about" },
    { label: "References & Sources", to: "/references", testId: "footer-references-link" },
    { label: "Report a Correction", to: "/contact?topic=correction" },
    { label: "Contact", to: "/contact" },
  ] },
];

export default function Footer() {
  const { settings } = useSiteSettings();
  const columns = COLUMNS.map((c) => ({ ...c, links: c.links.filter((l) => l.to !== "/explore/themes" || settings.explore_themes) }));
  return (
    <footer className="border-t border-border bg-muted/40" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="flex flex-col justify-between gap-8 md:flex-row">
          <div className="max-w-sm">
            <div className="flex items-center">
              <span className="font-serif text-2xl font-bold text-foreground">
                Question<span className="text-primary">God</span>
              </span>
            </div>
            <p className="mt-4 font-serif text-lg italic text-muted-foreground">
              "Asking God isn't rebellion. It's relationship."
            </p>
          </div>
          <div className="grid grid-cols-2 gap-8 text-sm sm:grid-cols-3 sm:gap-12" data-testid="footer-columns">
            {columns.map((col) => (
              <div key={col.title}>
                <p className="mb-3 font-mono text-xs uppercase tracking-[0.2em] text-gold">{col.title}</p>
                <ul className="space-y-2 text-muted-foreground">
                  {col.links.map((l) => (
                    <li key={l.to}><Link className="hover:text-foreground" to={l.to} data-testid={l.testId || `footer-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{l.label}</Link></li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-10 border-t border-border pt-6 text-xs text-muted-foreground">
          <p data-testid="footer-copyright">QuestionGod.org is a project of WordAmp. Copyright &copy; {new Date().getFullYear()}. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}
